import React from 'react'
import { withPrefix } from 'gatsby'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import './ContentBreadcrumb.css'

const siteRoot = '/'

const ContentBreadcrumb = ({item}) => {
    if(!item) return null;
    return (
        <Breadcrumb data-wio-id={item.id} className="pl-0">
            <li className="breadcrumb-item">
                <a href={siteRoot}>Home</a>
            </li>
            <li className="breadcrumb-item">
                <a href={siteRoot + `Division/Research`}>Research Division</a>
            </li>
            {
                item.data.featured === "Yes" &&
                <li className="breadcrumb-item">
                    <a href={withPrefix("/")}>Featured</a>
                </li>
            }
            {
                item.data.featured === "No" &&
                <li className="breadcrumb-item">
                    <a href={withPrefix("/allcontent")}>All Research Content</a>
                </li>
            }
            <Breadcrumb.Item active>{item.data.title}</Breadcrumb.Item>
        </Breadcrumb>     
    )
}

export default ContentBreadcrumb;